import { createContext, useContext } from 'react'

export type TOperation = () => Promise<void>

export type TFinishOperations = () => Promise<void>

interface IDelayedOperationContext {
  addOperation: (operation: TOperation) => () => void
  finishOperations: TFinishOperations
  finishOperationsInProgress: boolean
  hasRegistredOperations: boolean
}

export const DelayedOperationContext = createContext<IDelayedOperationContext>({
  addOperation: () => () => true,
  finishOperations: () => Promise.resolve(),
  finishOperationsInProgress: false,
  hasRegistredOperations: false,
})

export const useDelayedOperationContext = () => useContext(DelayedOperationContext)
